import type { CSSProperties, RefObject } from "react";
import { motion } from "framer-motion";
import { Cscrollable } from "../Cscrollable";
import type { CdropdownOption } from "./Cdropdown.types";
import { DROPDOWN_SCROLL_DIRECTION } from "./constants";
import { DropdownOptionItem } from "./DropdownOptionItem";
import { buildScrollableStyle, resolveOptionsAnimate, } from "./dropdown-surface-styles";
import { resolveDropdownOptionViewState } from "./option-state";
import { dataEl, type DataElScope } from "@/utils/dataEl";
interface DropdownOptionsListProps {
    dataElScope: DataElScope;
    options: CdropdownOption[];
    selectedKey: string | null;
    hoveredIndex: number | null;
    effectiveActiveIndex: number | null;
    isAnimating: boolean;
    isClosing: boolean;
    optionsWrapperStyle: CSSProperties;
    optionsViewportStyle: CSSProperties;
    optionsViewportHeight: number | null;
    maxHeight: number | undefined;
    resolvedScrollFadeSize: number;
    scrollVerticalFadeTopSize: number | undefined;
    scrollVerticalFadeBottomSize: number | undefined;
    scrollVerticalFadeMiddleOpacity: number | undefined;
    optionsContainerRef: RefObject<HTMLDivElement | null>;
    optionsContentRef: RefObject<HTMLDivElement | null>;
    onOptionElementRef: (input: {
        index: number;
        element: HTMLDivElement | null;
    }) => void;
    onOptionMouseEnter: (input: {
        index: number;
        isDisabled: boolean;
    }) => void;
    onOptionMouseLeave: () => void;
    onOptionClick: (option: CdropdownOption) => void;
}
export function DropdownOptionsList({ dataElScope, options, selectedKey, hoveredIndex, effectiveActiveIndex, isAnimating, isClosing, optionsWrapperStyle, optionsViewportStyle, optionsViewportHeight, maxHeight, resolvedScrollFadeSize, scrollVerticalFadeTopSize, scrollVerticalFadeBottomSize, scrollVerticalFadeMiddleOpacity, optionsContainerRef, optionsContentRef, onOptionElementRef, onOptionMouseEnter, onOptionMouseLeave, onOptionClick, }: DropdownOptionsListProps) {
    return (
    <motion.div data-el={dataEl(dataElScope, "OptionsList/Viewport")} initial={false} animate={resolveOptionsAnimate(optionsViewportHeight)} transition={{ duration: 0.24, ease: [0.2, 0.8, 0.2, 1] }} style={optionsViewportStyle}>
      <Cscrollable dataElScope={dataElScope} direction={DROPDOWN_SCROLL_DIRECTION.Vertical} fadeSize={resolvedScrollFadeSize} verticalFadeTopSize={scrollVerticalFadeTopSize} verticalFadeBottomSize={scrollVerticalFadeBottomSize} verticalFadeMiddleOpacity={scrollVerticalFadeMiddleOpacity} firstItemSpacing={0} scrollRef={optionsContainerRef} style={buildScrollableStyle({ optionsViewportHeight, maxHeight })}>
        <div data-el={dataEl(dataElScope, "OptionsList/Content")} ref={optionsContentRef} style={optionsWrapperStyle}>
          {options.map((option, index) => {
            const viewState = resolveDropdownOptionViewState({
                option,
                index,
                hoveredIndex,
                effectiveActiveIndex,
                selectedKey,
            });
            return (<DropdownOptionItem key={viewState.key} dataElScope={dataElScope} option={option} index={index} viewState={viewState} isAnimating={isAnimating} isClosing={isClosing} onElementRef={onOptionElementRef} onMouseEnter={onOptionMouseEnter} onMouseLeave={onOptionMouseLeave} onClick={onOptionClick}/>);
        })}
        </div>
      </Cscrollable>
    </motion.div>
    );
}
